var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"expiredRouteFilter"}},[_c('span',{staticClass:"expire-selector",on:{"click":function($event){$event.stopPropagation();return _vm.filterClicked()}}},[_vm._v(_vm._s(_vm.activeFilter.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }